import type { SrpRequestParams } from "@/providers/SRP/types";
import type { ZodSchema } from "zod";
import { PRICES_DATE_METADATA } from "../../constants";
import useSRP from "../useSRP";
import {
	type Params,
	type PricesDateMetadataDaily,
	PricesDateMetadataDailySchema,
	type PricesDateMetadataMonthly,
	PricesDateMetadataMonthlySchema,
} from "./types";

/**
 * Custom hook to fetch part data with optional schema validation
 *
 * @template T - The expected return type
 * @param {boolean} enabled - Flag to enable/disable the query
 * @param {Pick<SrpRequestParams, 'share_class_id' | 'type_id' | 'granularity'>} params - Request parameters
 * @param {string} [baseURL] - Optional base URL for the API request
 * @returns {UseQueryResult<PricesDateMetadataMonthly|PricesDateMetadataDaily>} Query result containing the fetched data
 * @throws {Error} When used outside of SrpApiContext
 */
export default function usePricesDateMetadata(
	enabled: boolean,
	params: Params,
	baseURL?: string,
) {
	const schema =
		params.granularity === "days"
			? PricesDateMetadataDailySchema
			: PricesDateMetadataMonthlySchema;
	return useSRP<PricesDateMetadataDaily | PricesDateMetadataMonthly>(
		PRICES_DATE_METADATA,
		enabled,
		params,
		schema,
		baseURL,
	);
}
